// src/components/common/PhotoViewer.js
import React from 'react';

const PhotoViewer = ({ photo, onClose }) => {
    if (!photo) return null;

    const gradients = {
        1: 'linear-gradient(to bottom right, #fcd34d, #fb923c, #f472b6)',
        2: 'linear-gradient(to bottom right, #93c5fd, #67e8f9, #5eead4)',
        3: 'linear-gradient(to bottom right, #ddd6fe, #f9a8d4, #e879f9)'
    };

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
            onClick={onClose}
        >
            <div className="max-w-2xl w-full" onClick={(e) => e.stopPropagation()}>
                <div className="bg-white rounded-t-2xl p-4">
                    <div className="flex items-center justify-between mb-2">
                        <div>
                            <h3 className="font-bold text-gray-800">{photo.title}</h3>
                            <p className="text-sm text-gray-500">{photo.time}</p>
                        </div>
                        <button
                            onClick={onClose}
                            className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition"
                        >
                            <span className="text-xl text-gray-600">×</span>
                        </button>
                    </div>
                </div>

                <div
                    className="aspect-video rounded-b-2xl overflow-hidden shadow-2xl"
                    style={{ backgroundImage: gradients[photo.image] }}
                >
                    <div className="w-full h-full flex items-center justify-center relative">
                        <div className="absolute inset-0 bg-black bg-opacity-10"></div>
                        <div className="text-center z-10">
                            <div className="text-8xl mb-4">
                                {photo.image === 1 ? '👧🏽' : photo.image === 2 ? '👦🏽' : '👧🏾'}
                            </div>
                            <div className="bg-white bg-opacity-90 px-6 py-3 rounded-full">
                                <p className="text-sm text-gray-700 font-medium">{photo.desc}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-4 text-center">
                    <button
                        onClick={onClose}
                        className="bg-white text-gray-700 px-6 py-3 rounded-full font-semibold hover:bg-gray-100 transition"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PhotoViewer;